import React, { FC, ReactNode } from "react";
import { Spinner } from "react-bootstrap";
import { Variant } from "react-bootstrap/esm/types";

interface CustomSpinnerComponentProps {
  isLoading: boolean;
  width: string;
  height: string;
  children: ReactNode;
  showNoDataFoundMsg?: boolean;
  animation?: "grow" | "border" | undefined;
  variant?: Variant;
  isShowCardStyle?: boolean;
}

const CustomSpinnerComponent: FC<CustomSpinnerComponentProps> = ({
  isLoading,
  width,
  height,
  children,
  showNoDataFoundMsg = false,
  animation = "grow",
  variant = "primary",
  isShowCardStyle = false,
}) => {
  const classNames = `d-flex justify-content-center align-items-center ${
    isShowCardStyle ? "bg-card shadow-sm" : ""
  }`;

  return (
    <div>
      {isLoading ? (
        <div
          style={{ minHeight: height, minWidth: width }}
          className={classNames}
        >
          <Spinner animation={animation} variant={variant} />
        </div>
      ) : showNoDataFoundMsg ? (
        <p>Data not found</p> /* need refactoring here */
      ) : (
        children
      )}
    </div>
  );
};
export default CustomSpinnerComponent;
